export default {
      id: "Icon--video-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--video",
      toString: function () {
        return this.url;
      }
    }